'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    .col-xs-6 {\n      max-width: 100%;\n      flex-basis: 100%;\n    }\n  '], ['\n    .col-xs-6 {\n      max-width: 100%;\n      flex-basis: 100%;\n    }\n  ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _MerchandiseIds = require('self-service-api/constants/MerchandiseIds');

var _ServiceItem = require('./optional-items/ServiceItem');

var _ServiceItem2 = _interopRequireDefault(_ServiceItem);

var _UIGrid = require('UIComponents/grid/UIGrid');

var _UIGrid2 = _interopRequireDefault(_UIGrid);

var _H = require('UIComponents/elements/headings/H1');

var _H2 = _interopRequireDefault(_H);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _responsiveBreakpoints = require('../../utils/responsiveBreakpoints');

var _responsiveBreakpoints2 = _interopRequireDefault(_responsiveBreakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledH1 = (0, _styledComponents2.default)(_H2.default).withConfig({
  displayName: 'Services__StyledH1'
})(['margin-bottom:8px !important;']);

var ButtonGrid = (0, _styledComponents2.default)(_UIGrid2.default).withConfig({
  displayName: 'Services__ButtonGrid'
})(['', ';'], _responsiveBreakpoints2.default.tablet(_templateObject));

function Services(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle;

  return _react2.default.createElement(
    'div',
    { className: 'm-bottom-12' },
    _react2.default.createElement(
      StyledH1,
      null,
      title
    ),
    subtitle,
    _react2.default.createElement(
      ButtonGrid,
      { className: 'm-top-4' },
      _react2.default.createElement(_ServiceItem2.default, { merchandiseId: _MerchandiseIds.SERVICE_INBOUND_CONSULTING_MONTHLY }),
      _react2.default.createElement(_ServiceItem2.default, { merchandiseId: _MerchandiseIds.SERVICE_INBOUND_CONSULTING_ONGOING }),
      _react2.default.createElement(_ServiceItem2.default, { merchandiseId: _MerchandiseIds.SERVICE_TECHNICAL_CONSULTING_ONGOING }),
      _react2.default.createElement(_ServiceItem2.default, { merchandiseId: _MerchandiseIds.SERVICE_PREMIUM_CONSULTING }),
      _react2.default.createElement(_ServiceItem2.default, { merchandiseId: _MerchandiseIds.SERVICE_TRAINING_MARKETING_FUNDAMENTALS })
    )
  );
}

exports.default = Services;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/bundle-page/Services.js
// module id = 718
// module chunks = 3 4